import {
  BRAZIL_COORDINATES,
  DraggableMarkerMap,
  MainButton,
  PageWrapper,
  STATUSPAGE,
} from '@repo/ui';
import { Card, Col, Row } from 'reactstrap';

import { useConfirmOrEditMarkerLocationOnMap } from '../hooks/use-confirm-or-edit-marker-location-on-map';

export const ConfirmOrEditMarkerLocationOnMap = () => {
  // Hooks
  const {
    id,
    state,
    newMarkerLocationCoordinates,
    updateInternshipLocationRequestStatus,
    navigate,
    requestUpdateInternshipLocation,
  } = useConfirmOrEditMarkerLocationOnMap();

  return (
    <PageWrapper
      title={`${id ? 'Editar' : 'Confirmar'} Localização do Marcador no Mapa`}
    >
      <div className="d-flex flex-column">
        <h4>
          {id ? 'Edição' : 'Confirmação'} da localização do marcador no mapa
        </h4>
        <p className="text-muted">
          Se estiver incorreta, coloque o marcador no seu endereço para nos
          ajudar a encontrá-lo facilmente.
        </p>
      </div>

      <Card className="p-3">
        <Row>
          <Col className="d-flex flex-column justify-content-center align-items-end">
            <DraggableMarkerMap
              lat={state?.value?.lat || BRAZIL_COORDINATES.lat}
              lng={state?.value?.lng || BRAZIL_COORDINATES.lng}
              handleMarkerPositionChange={(lat, lng) => {
                newMarkerLocationCoordinates.current = { lat, lng };
              }}
            />

            <div className="d-flex gap-4 justify-content-end mt-3">
              <button
                className="btn p-1 fw-medium btn-link"
                onClick={() => navigate('/cadastros/locais-de-estagio')}
                color="primary"
                disabled={
                  updateInternshipLocationRequestStatus === STATUSPAGE.LOADING
                }
              >
                Pular etapa
              </button>

              <MainButton
                onClick={() =>
                  requestUpdateInternshipLocation({
                    id: state?.value?.id,
                    lat:
                      newMarkerLocationCoordinates.current?.lat ||
                      state?.value?.lat,
                    lng:
                      newMarkerLocationCoordinates.current?.lng ||
                      state?.value?.lng,
                    countryId: state?.value?.countryId,
                  })
                }
                isDisabled={
                  updateInternshipLocationRequestStatus === STATUSPAGE.LOADING
                }
                isLoading={
                  updateInternshipLocationRequestStatus === STATUSPAGE.LOADING
                }
              >
                Confirmar localização do marcador
              </MainButton>
            </div>
          </Col>
        </Row>
      </Card>
    </PageWrapper>
  );
};
